export default __webpack_public_path__ + "static/media/InPersonMeetings-hover.cbb47649.svg";